import { CustomUseQueryOptions } from '../types';
import { hasNonEmptyProp } from '@/libs/common/utils';
import type { ApiInstance, EventDetail } from '@/libs/sdk/api';
import { useQuery } from '@tanstack/react-query';

export type EventDetailSearchParams = {
  eventId: string;
};

export const buildEventDetailQueryOptions = (
  api: ApiInstance,
  searchParams: EventDetailSearchParams,
  options?: CustomUseQueryOptions<EventDetail>
) => {
  const { queryKey, enabled = true, ...rest } = options || {};

  return {
    ...rest,
    enabled: enabled && hasNonEmptyProp(searchParams, ['eventId']),
    queryKey: [queryKey, 'EventDetail', searchParams],
    queryFn: async () => {
      const { data } = await api.market.getEventDetail({ id: searchParams.eventId });
      return data;
    },
  };
};

export const useEventDetail = (
  api: ApiInstance,
  searchParams: EventDetailSearchParams,
  options?: CustomUseQueryOptions<EventDetail>
) => {
  return useQuery(buildEventDetailQueryOptions(api, searchParams, options));
};
